export const DEFAULT_PAST_MONTHS_VISIBILITY_LIMIT = 15;
export const DEFAULT_FUTURE_MONTHS_VISIBILITY_LIMIT = 12;
